/* DSL TikTok Pixel events — vereist window.ttq globally + consent.marketing */
(function(){
  function ready(cb){
    var iv = setInterval(function(){ if (window.ttq && typeof window.ttq.track === "function") { clearInterval(iv); cb(); } }, 200);
    setTimeout(function(){ clearInterval(iv); }, 10000);
  }
  ready(function(){
    var c = window.DSL_CONSENT && window.DSL_CONSENT.get();
    if (c && c.marketing === false) return;
    if (location.pathname.indexOf("/products/") === 0) {
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      if (m) fetch("/products/" + m[1] + ".js").then(function(r){return r.json();}).then(function(p){
        ttq.track("ViewContent", {contents: [{content_id: String(p.id), content_name: p.title, content_type: "product"}], value: p.price/100, currency: "EUR"});
      });
    }
    document.addEventListener("dsl:cart:add", function(e){
      var d = e.detail || {};
      ttq.track("AddToCart", {contents: [{content_id: String(d.variant_id||d.product_id), content_name: d.product_title}], value: (d.price||0)/100, currency: "EUR"});
    });
  });
})();